<!-- お知らせ -->
<template>
  <h2 class="com_title1">
    <span>お知らせ</span>
    <router-link to="/news" class="button1">
      <span class="text">
        <span class="text__item">一覧はこちら</span>
        <span class="text__item" aria-hidden="true">一覧はこちら</span>
      </span>
    </router-link>
  </h2>
  <div class="com_topic_list1">
    <div v-for="info in infoListData" :key="info.contentId">
      <div class="meta1">
        <span class="date1 roboto">{{ info.postPeriod }}</span
        ><span class="com_tag1">{{ info.subCategoryName }}</span>
      </div>
      <div class="body1">
        <router-link
          :to="`/${info.detailPath}/categoryId/${info.categoryId}/contentsId/${info.contentId}`"
          class="com_link1"
          >{{ info.contentsTitle }}</router-link
        >
        <span v-if="info.fileFlg" class="com_icon_doc1"></span>
        <span v-if="info.newFlg" class="com_icon_new">NEW</span>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { AxiosError } from "axios";
import apiAuthClient from "@/util/apiClientAuth";
import {
  outputDebugLogs,
  formatMessage,
  getTargetDate,
  getUserInfo,
} from "@/Common";
import { AppConstants } from "@/constants/AppConstants";
import messages from "@/assets/messages.json";
import { useUserParmitionStore } from "@/store/userParmitionStore";

interface Item {
  categoryId: string;
  categoryName: string;
  subCategoryName: string;
  contentId: string;
  postPeriod: string;
  contentsTitle: string;
  imptFlg: boolean;
  newFlg: boolean;
  fileFlg: boolean;
  detailPath: string;
  updateFormPath: string;
}

export default defineComponent({
  name: "NewsAreaComponent",
  setup() {
    const infoListData = ref<Item[]>([]);
    const { agCode, userId } = getUserInfo();
    const { getCategoryIdByName } = useUserParmitionStore();
    const categoryId = ref<string | null>(null);

    onMounted(async () => {
      try {
        // お知らせのカテゴリIDを取得
        categoryId.value = getCategoryIdByName(AppConstants.CATEGORY_NAME_INFO);

        outputDebugLogs("お知らせ一覧取得");

        // お知らせ取得API
        const response = await apiAuthClient.post(
          "/api/Info/getPortalTopInfo",
          {
            systemKbn: process.env.VUE_APP_SYSTEM_KBN,
            userId: userId.value,
            agCode: agCode.value,
            targetDate: getTargetDate(""),
          }
        );
        infoListData.value = response.data.infoListData;
        outputDebugLogs(
          "お知らせ一覧取得成功 件数：" + infoListData.value.length
        );
      } catch (error: unknown) {
        const axiosError = error as AxiosError;
        outputDebugLogs("Error: " + axiosError.message);
        alert(formatMessage(messages.ERR_SYS003, "お知らせ一覧取得"));
      } finally {
        //何か入れるかも
      }
    });

    return { infoListData, categoryId };
  },
});
</script>
